/**
 * BackgroundGenBanner — 백그라운드 생성 진행 배너
 *
 * SSE 모달 닫은 후 AIStudio에 표시.
 * current가 null이면 렌더하지 않는다.
 */

import { Spinner } from '@/components/ui'
import { useBackgroundGenPoller } from '@/hooks/useBackgroundGenPoller'
import styles from './BackgroundGenBanner.module.css'

export function BackgroundGenBanner() {
  const current = useBackgroundGenPoller()

  if (!current) return null

  const { count, completedSoFar } = current
  const remaining = count - completedSoFar

  return (
    <div className={styles.banner}>
      <Spinner size="sm" />
      <div className={styles.text}>
        <span className={styles.title}>
          사진 {count}장 생성 중... ({completedSoFar}장 완료 / {remaining}장 남음)
        </span>
        <span className={styles.subtitle}>완료되면 자동으로 표시됩니다</span>
      </div>
    </div>
  )
}
